import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    badge: {
        alignItems: 'center',
        background:
            theme.palette.type === 'dark'
                ? 'linear-gradient(135deg, rgba(99, 167, 255, 0.16), rgba(144, 92, 243, 0.2))'
                : 'linear-gradient(135deg, rgba(99, 167, 255, 0.1), rgba(144, 92, 243, 0.12))',
        border: '1px solid rgba(113, 84, 198, 0.35)',
        borderRadius: 999,
        color: theme.palette.type === 'dark' ? '#cfc4ff' : '#59419f',
        display: 'inline-flex',
        flexShrink: 0,
        fontSize: 10,
        fontWeight: 700,
        gap: 6,
        letterSpacing: '0.015em',
        lineHeight: 1.2,
        padding: '4px 8px',
        textTransform: 'none',
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
    },
    dot: {
        background:
            'radial-gradient(circle at 30% 25%, #fff 0%, #a9f9ff 18%, #63a7ff 42%, #905cf3 72%, #e36ac6 100%)',
        borderRadius: '50%',
        boxShadow: '0 0 6px rgba(113, 84, 198, 0.55)',
        height: 9,
        width: 9,
    },
}));

export const AssistantGeneratedBadge = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <span className={classes.badge}>
            <span aria-hidden="true" className={classes.dot} />
            {t('Assistant.PerformedByWarboxAI')}
        </span>
    );
};

export default AssistantGeneratedBadge;
